import { ButtonComponent } from 'baseComponents/ButtonComponent';
import { Flex, Spin } from 'antd';
import { SelectComponent } from 'baseComponents/SelectComponent';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { TextInputComponent } from 'baseComponents/TextInputComponent';
import { useGetFranchiseOwners } from 'hooks/useGetFranchiseOwners';

export type TestUserFormValues = {
  nickname: string;
  email: string;
  franchiseOwner: number;
};

type AdminTestUserFormProps = {
  onSubmit: (data: TestUserFormValues) => void;
  onCancel?: () => void;
  defaultValues?: Partial<TestUserFormValues>;
  submitButtonLabel?: string;
};

export const userFormSchema = Yup.object().shape({
  nickname: Yup.string().required('Nickname is required.'),
  email: Yup.string().required('Email is required.'),
  franchiseOwner: Yup.number().required('Franchise owner is required.'),
});

const initialState = {
  phone: '',
  nickname: '',
  email: '',
  franchiseOwner: undefined,
};

export const AdminTestUserPushForm = ({
  onCancel,
  onSubmit,
  defaultValues,
  submitButtonLabel = 'Submit',
}: AdminTestUserFormProps) => {
  const franchiseOwners = useGetFranchiseOwners();

  const { handleSubmit, control } = useForm<TestUserFormValues>({
    mode: 'onSubmit',
    defaultValues: {
      ...initialState,
      ...defaultValues,
    },
    resolver: yupResolver(userFormSchema),
  });

  const handleSubmitCallback = async (data: TestUserFormValues) => {
    onSubmit(data);
  };

  return (
    <form
      style={{ flex: 1, flexBasis: '100%' }}
      onSubmit={handleSubmit(handleSubmitCallback)}
    >
      <Flex vertical gap={16} style={{ padding: 2 }}>
        <Controller
          name='nickname'
          control={control}
          render={({ field, fieldState }) => (
            <TextInputComponent
              label='Nickname'
              error={fieldState.error?.message}
              {...field}
            />
          )}
        />


        <Controller
          name='email'
          control={control}
          render={({ field }) => (
            <TextInputComponent label='Email' {...field} />
          )}
        />


        <Controller
          name='franchiseOwner'
          control={control}
          render={({ field, fieldState }) => (
            <Spin spinning={franchiseOwners.isLoading}>
              <SelectComponent
                placeholder='Franchise owner'
                options={
                  franchiseOwners.data?.map(({ email, id }) => ({
                    label: email,
                    value: id,
                  })) ?? []
                }
                error={
                  fieldState.error?.message ||
                  franchiseOwners.error?.response?.data?.message
                }
                {...field}
              />
            </Spin>
          )}
        />
      </Flex>

      <Flex gap={8} style={{ maxWidth: 648, marginTop: 64 }}>
        <ButtonComponent
          label={submitButtonLabel}
          appereance='primary'
          size='middle'
          fullWidth
          htmlType='submit'
        />
        <ButtonComponent
          label='Cancel'
          onClick={onCancel}
          appereance='secondary'
          size='middle'
          fullWidth
        />
      </Flex>
    </form>
  );
};
